import React from 'react';
import { PropertyGrid, TabPane, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import Model from "./ArrayPrimitiveAttributeDetailModel.js";
import DetailEditor from "./AttributeDetailEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-attributes.detail.type.ArrayPrimitiveAttributeDetailEditor');
export default function ArrayPrimitiveAttributeDetailEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  if (!value) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TabPane, {
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "detail",
      tabName: t('detail'),
      children: /*#__PURE__*/_jsx(DetailEditor, {
        ...props
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "list",
      tabName: t('list'),
      children: /*#__PURE__*/_jsxs(PropertyGrid, {
        variant: "attributeDetailEditor|editor",
        children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('paneVariant'),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: Model.getPaneVariant(value),
            eventData: "setPaneVariant",
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('layout'),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: Model.getLayout(value),
            eventData: "setLayout",
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('morePopupVariant'),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: Model.getMorePopupVariant(value),
            eventData: "setMorePopupVariant",
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('moreToggleVariant'),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: Model.getMoreToggleVariant(value),
            eventData: "setMoreToggleVariant",
            onChange: onModelChange
          })
        })]
      })
    })]
  });
}